import {
    SensorSimulator35EqvFocalLengthFromReal,
    SensorSimulatorFOV,
    SensorSimulatorFootprint,
    SensorSimulatorGSD,
    SensorSimulatorRealFocalLengthFrom35Eqv,
    SensorSimulatorRealFocalLengthFromGSD,
} from ".";

import { Grid } from "@mui/material";

export function SensorSimulatorForm() {
    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <SensorSimulatorGSD />
            </Grid>
            <Grid size={12}>
                <SensorSimulator35EqvFocalLengthFromReal />
            </Grid>
            <Grid size={12}>
                <SensorSimulatorRealFocalLengthFromGSD />
            </Grid>
            <Grid size={12}>
                <SensorSimulatorRealFocalLengthFrom35Eqv />
            </Grid>
            <Grid size={12}>
                <SensorSimulatorFOV />
            </Grid>
            <Grid size={12}>
                <SensorSimulatorFootprint />
            </Grid>
        </Grid>
    );
}
